import { FC } from "react"
import { Box, Tooltip } from "@mui/material"

interface IProps {
  phones: string[]
}

export const PhonesCell: FC<IProps> = ({ phones }) => {
  if (!phones?.length) return <Box sx={{ color: "text.disabled" }}>—</Box>
  return (
    <Tooltip title={phones.join("\n")}>
      <Box
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {phones.join(", ")}
      </Box>
    </Tooltip>
  )
}
